enum OrderBillingForecastPreOrderType {
  MANUAL_INPUT = 'MANUAL_INPUT',
  CALCULATED_FROM_ORDER_DATE = 'CALCULATED_FROM_ORDER_DATE',
  CALCULATED_FROM_INTEGRATION_DATE = 'CALCULATED_FROM_INTEGRATION_DATE',
  USE_DELIVERY_WINDOW_START_DATE = 'USE_DELIVERY_WINDOW_START_DATE',
  USE_DELIVERY_WINDOW_END_DATE = 'USE_DELIVERY_WINDOW_END_DATE',
}

export default OrderBillingForecastPreOrderType;
